<!--  -->
<template>
  <div>
    <div class="Nav">
      <ul class="Nav_ul">
        <li v-for="(item, index) in navList" :key="index" :index="index + 1">
          <a :data-url="item.url" @click="toUrl" :class="fullPath==item.url?'active':''">{{ item.name }}</a>
        </li>
      </ul>
    </div>
    <!-- <el-menu
      class="el-menu-demo"
      mode="horizontal"
      background-color="#00a0e9"
      text-color="#fff"
    >
      <el-menu-item
        v-for="(item, index) in navList"
        :key="index"
        :index="index + 1"
      >
        <router-link :to="item.url">{{ item.name }}</router-link>
      </el-menu-item> -->

    <!--      <el-menu-item index="1">-->
    <!--        <router-link to="/">网站首页</router-link>-->
    <!--      </el-menu-item>-->
    <!--      <el-menu-item index="2">-->
    <!--        <router-link to="/Recruit">招聘公告</router-link>-->
    <!--      </el-menu-item>-->
    <!--      <el-menu-item index="3">-->
    <!--        <router-link to="/">考试报名</router-link>-->
    <!--      </el-menu-item>-->
    <!--      <el-menu-item index="4">-->
    <!--        <router-link to="/">聘用公示</router-link>-->
    <!--      </el-menu-item>-->
    <!--      <el-menu-item index="5">-->
    <!--        <router-link to="/">相关通知</router-link>-->
    <!--      </el-menu-item>-->
    <!-- </el-menu> -->
    <div class="banner">
      <div class="banner_back_box">
        <div class="banner_back">
          <div class="back_top">
            <img src="../assets/img/logo01.png" alt="" />
            <h1>招聘考试网上服务平台</h1>
          </div>
          <div class="back_botm">
            <p v-if="telephone">咨询电话：{{ telephone }}</p>
            <p v-if="technical_support">技术支持：{{ technical_support }}</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      telephone: "",
      technical_support: "",
      selectedNav: 0,
      navList: {},
      fullPath: "",
    };
  },

  components: {},

  computed: {},

  mounted() {
    this.fullPath = decodeURI(this.$route.fullPath);
    this.getSetting();
    this.getNav();
  },

  watch: {
    '$route' () {
      this.fullPath = decodeURI(this.$route.fullPath);
    }
  },
  methods: {
    getSetting() {
      let _this = this;
      _this.request("api/index/setting", {}, "get").then((res) => {
        if (res.data.status == "success") {
          let settingData = res.data.data.index_setting;
          _this.telephone = settingData.telephone;
          _this.technical_support = settingData.technical_support;
        }
      });
    },
    getNav() {
      let _this = this;
      _this.request("api/index/nav", {}, "get").then((res) => {
        if (res.data.status == "success") {
          let navList = res.data.data.index_information;
          for (var i = 0; i < navList.length; i++) {
            if (navList[i]["type"] == 1) {
              navList[i]["url"] =
                "/Recruit?navid=" +
                navList[i]["id"] +
                "&type=1" +
                "&name=" +
                navList[i]["name"];
            }
            if (navList[i]["type"] == 3) {
              navList[i]["url"] =
                "/Exam?navid=" +
                navList[i]["id"] +
                "&type=3" +
                "&name=" +
                navList[i]["name"];
            }
          }
          _this.navList = navList;
          // console.log(_this.navList);
        }
      });
    },
    toUrl(e){
      var url = e.target.dataset.url;
      if (url=="/my"){
        if(this.isLogin()===false){
          return;
        }
      }
      this.$router.push(url)
    }
  },
};
</script>
<style lang='less' scoped>
.el-menu-demo {
  height: 0.9rem;
  padding-left: 1.93rem;
  border: none !important;
  .el-menu-item {
    line-height: 0.9rem !important;
    width: 1.49rem;
    height: 0.9rem;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-right: 0.2rem;
    a {
      text-decoration: none;
      font-size: 0.26rem;
    }
  }
  .el-menu-item:hover {
    background-color: #fff !important;
    width: 1.49rem;
    height: 0.6rem;
    align-items: center;
    border-radius: 0.2rem;
    margin-top: 0.15rem;
    a {
      color: #00a0e9;
      line-height: 0.57rem;
    }
  }
}
.Nav {
  background-color: #00a0e9;
  .Nav_ul {
    display: flex;
    height: 0.9rem;
    padding-left: 1.93rem;
    li {
      // padding: 0 0.32rem;
      line-height: 0.9rem;
      width: 1.6rem;
      text-align: center;
      cursor: pointer;
      a {
        font-size: 0.26rem;
        color: #fff;
      }
      .active{
        color: #00a0e9;
        width: 1.49rem;
        padding: 0.1rem 0.2rem;
        background-color: #fff;
        border-radius: 0.2rem;
      }
    }
    li:hover {
      a {
        color: #00a0e9;
        width: 1.49rem;
        padding: 0.1rem 0.2rem;
        background-color: #fff;
        border-radius: 0.2rem;
      }
    }
  }
}
.banner {
  background-image: url("../assets/img/banner.jpg");
  background-repeat: round;
  background-size: 100%;
  height: 5.17rem;
  display: flex;
  align-items: center;
  .banner_back_box{
    width: 100%;
    background: #e8e8e88c;
    .banner_back {
      height: 1.61rem;
      display: flex;
      align-items: center;
      justify-content: space-between;
      .back_top {
        display: flex;
        align-items: center;
        margin-left: 1.67rem;
        img {
          width: 1.38rem;
          margin-right: 0.22rem;
        }
        h1 {
          font-weight: bold;
          color: #0b88d0;
          font-size: 0.75rem;
        }
      }
      .back_botm {
        margin-right: 0.8rem;
        p {
          font-size: 0.33rem;
          color: #000;
        }
      }
    }
  }

}
</style>
